import { Routes } from '@angular/router';
import { IFrameTestComponent } from './Pages/i-frame-test/i-frame-test.component';

const watermanagerRouteConfig: Routes = [
  { path: '', component: IFrameTestComponent, pathMatch: 'full' },
];

export default watermanagerRouteConfig;
